module.exports = __webpack_public_path__ + "img/smart-billing-logo.ed8eb1b1.svg";